import "./DatePicker.scss";

import { CalendarNavigationItem } from "@progress/kendo-react-dateinputs";

import type { CalendarNavigationItemProps } from "@progress/kendo-react-dateinputs";

const CustomNavigationItem = (props: CalendarNavigationItemProps) => (
  <CalendarNavigationItem {...props}>
    {props.isRangeStart && props.view === 0 ? "Jan" : props.children}
  </CalendarNavigationItem>
);

export { CustomNavigationItem };
